L.Link = L.Class.extend({
	

	
	options:{
		
        blankPage: true,
        url:'#'
	},
	
	initialize(options, source){
		L.Util.setOptions(this, options);

		this._source = source;
		this._source._link = this;
	},
	
	setContent: function(content){
		
	},
	
	getContent: function(){
		return false;
	},
	
	toJSONable: function(){
		var jsonable= {};
		
		jsonable['type'] = "external";
		jsonable['options'] = this.options;
		return jsonable;
	}
	
});


//@section Link methods
L.Layer.include({

	// @method bindLink(content: String|HTMLElement|Function|Link, options?: Link options): this
	// Binds a link to the layer with the passed `content` and sets up the
	// necessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindLink: function (content, options) {

		if (content instanceof L.Link) {
			if (options){
			Util.setOptions(content, options);
			}
			this._link = content;
			content._source = this;
		} else {
			if (!this._link || options) {
				this._link = new L.Link(options, this);
			}
			this._link.setContent(content);
		}

		if (!this._linkHandlersAdded) {
			this.on({
				click: this._openLink
			});
			this._linkHandlersAdded = true;
		}

		return this;
	},

	// @method unbindLink(): this
	// Removes the link previously bound with `bindLink`.
	unbindLink: function () {
		if (this._link) {
			this.off({
				click: this._openLink
			});
			this._linkHandlersAdded = false;
			this._link = null;
		}
		return this;
	},

	// @method openLink(latlng?: LatLng): this
	// Opens the bound link at the specified `latlng` or at the default link anchor if no `latlng` is passed.
	openLink: function (layer) {

		if (this._link ) {
			if (this._link.options.url) {
				if (this._link.options.blankPage){
					window.open(this._link.options.url,'_blank');
				}else{
					window.location.href = this._link.options.url;
				}
			}else{
				void 0;
			}
		}

		return this;
	},



	// @method setLinkContent(content: String|HTMLElement|Link): this
	// Sets the content of the link bound to this layer.
	setLinkContent: function (content) {
		if (this._link) {
			this._link.setContent(content);
		}
		return this;
	},

	// @method getLink(): Link
	// Returns the link bound to this layer.
	getLink: function () {
		return this._link;
	},

	_openLink: function (e) {
		var layer = e.layer || e.target;

		if (!this._link) {
			return;
		}

		if (!this._map) {
			return;
		}

		// prevent map click
		L.DomEvent.stop(e);
		this.openLink(e.layer || e.target);

	},
	
	suspendLinkOpening: function(isSuspending){
		if (isSuspending){
			if (this._link) {
				if (this._linkHandlersAdded) {
					this.off({
						click: this._openLink,
					});
					this._linkHandlersAdded = false;
				}
			}
		}else{
			if (this._link) {				
				if (!this._linkHandlersAdded) {
					this.on({
						click: this._openLink,
					});
					this._linkHandlersAdded = true;
				}
			}
		}
	},


});